import { Check } from 'lucide-react';
import { useBackLayer } from '@/lib/backStack';

export interface TitleMenuItem {
  key: string;
  label: string;
  /** Число справа (например, «12 новых»). */
  note?: string;
}

interface Props {
  items: TitleMenuItem[];
  selected: string;
  onSelect: (key: string) => void;
  onClose: () => void;
}

/** Меню под заголовком: список вариантов с галочкой у выбранного. */
export function TitleMenu({ items, selected, onSelect, onClose }: Props) {
  useBackLayer(onClose);
  return (
    <>
      <div className="scrim" onClick={onClose} aria-hidden />
      <div className="menu" role="menu">
        {items.map((it) => (
          <button
            key={it.key}
            type="button"
            role="menuitemradio"
            aria-checked={selected === it.key}
            onClick={() => { onSelect(it.key); onClose(); }}
          >
            <Check aria-hidden />
            {it.label}
            {it.note && <span className="n tnum">{it.note}</span>}
          </button>
        ))}
      </div>
    </>
  );
}
